<template id="upload-input">
  <div>
    <!-- PRETTY FILE INPUT HIDDEN -->
    <div class="input-group fileUploadDiv">
      <input type="text" class="form-control" placeholder="Select File..." :value="filenameVal()" readonly>
      <span class="input-group-btn">
    <button v-if="file != null" class="btn btnUpload deleteBtn" type="button" @click="clearFile">
     <span class="fas fa-trash-alt" aria-hidden="true"></span>
    </button>
    <button class="btn btnUpload " type="button" @click="launchFilePicker">
     <span class="fas fa-folder-open" aria-hidden="true"></span>
    </button>
   </span>
    </div>
    <!-- REAL FILE INPUT HIDDEN  style="display:none" -->
    <ValidationProvider rules="required" v-slot="{errors, validate}" :name="hidden_id" tag="div" class="" v-if="required"
                        style="font-size: 0;">
      <input type="file" style="line-height: 0; height: 0; width: 0; font-size: 0"
             ref="file" :id="hidden_id" :name="hidden_id" :accept="accepted_file_type" v-uploader @change="validate"/>
      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
    </ValidationProvider>
    <input v-else style="line-height: 0; height: 0; width: 0; font-size: 0" type="file" ref="file" :id="hidden_id" :name="hidden_id" :accept="accepted_file_type" v-uploader
           :required="required"/>
  </div>
</template>

<script>
export default {
  name: "fileInput",
  props: ['selected_file', 'accepted_file_type', 'required', 'hidden_id', 'file_error_name'],
  data() {
    return {
      file: null
    }
  },
  directives: {
    uploader: {
      bind(el, binding, vnode) {
        el.addEventListener('change', e => vnode.context.file = e.target.files[0]);
      }
    },
  },
  watch: {
    file(val) {
      if (val !== null && val.type === 'application/pdf') {
        this.$emit('checking-file-name', this.file_error_name);
        this.$emit('checking-file', true);
        let sizeTemp = val.size / 1024000;
        let sizeOther1 = sizeTemp.toFixed(1);
        let temp_file = new FormData();
        temp_file.append('file', val)
        axios.post(this.crmApiPath + 'file/check_pdf/number_pages', temp_file, {headers: {'Content-Type': 'application/json'}}).then(num_pages => {
          if (num_pages.data > 1) {
            this.$snotify.confirm('', '', {
              closeOnClick: false,
              position: 'centerCenter',
              backdrop: 0.5,
              html: '<div class="snotifyToast__title">PDF NUMBER OF PAGES</div>' +
                  '<div class="snotifyToast__body">' +
                  'The PDF file you are trying to upload <strong class="red_color">contains more than 1 page</strong>.<br><br>' +
                  'This means that it <strong class="red_color">cannot be converted and compressed</strong> by ORCA.<br>' +
                  '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
                  '</div>',
              buttons: [
                {
                  text: 'Ok', action: (toast) => {
                    this.$snotify.remove(toast.id);
                    if (sizeOther1 >= 2) {
                      this.$snotify.confirm('', '', {
                        closeOnClick: false,
                        position: 'centerCenter',
                        backdrop: 0.5,
                        html: '<div class="snotifyToast__title">LARGE FILE SIZE</div>' +
                            '<div class="snotifyToast__body">' +
                            'This file is larger than 2MB<br><br><strong class="red_color">Please confirm that you have tried to compress this file.</strong>' +
                            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
                            '</div>',
                        buttons: [
                          {
                            text: 'Confirm', action: (toast) => {
                              this.$snotify.remove(toast.id);
                              this.$emit('checking-file', false);
                              this.$emit('checking-file-name', '');
                            }
                          },
                          {
                            text: 'Cancel', action: (toast) => {
                              this.$snotify.remove(toast.id);
                              this.$nextTick(() => {
                                this.file = null;
                                document.getElementById(this.hidden_id).value = "";
                                this.$emit('checking-file', false);
                                this.$emit('checking-file-name', '');
                              })
                            }
                          }
                        ]
                      });
                    }
                    else {
                      this.$snotify.remove(toast.id);
                      this.$emit('checking-file', false);
                      this.$emit('checking-file-name', '');
                    }
                  }
                },
              ]
            });
          }
          else {
            this.$emit('checking-file', false);
          }
        })
      }
      this.$emit('file-chosen', val);
    },
    selected_file() {
      if (this.selected_file === null) {
        this.file = null;
      }
    }
  },
  methods: {
    filenameVal() {
      if (this.file !== null) {
        return this.file.name
      }
    },
    launchFilePicker() {
      this.$refs.file.click();
    },
    clearFile() {
      this.file = null;
      document.getElementById(this.hidden_id).value = "";
    }
  }
}
</script>
<style scoped lang="scss">
.fileUploadDiv {
  height: 38px;

  input {
    height: 100%;
  }

  .input-group-btn {
    height: 100%;

    .btnUpload {
      height:           100%;
      border-radius:    0 0.25rem 0.25rem 0;
      float:            left;
      background-color: $bc_1;
      border-color:     $bc_1;
      color:            $white;

      &:hover, &:focus, &:active, &:active:focus, &.active:focus,
      &.focus, &:active.focus, &.active.focus {
        background-color: darken($bc_1, 15%);
        border-color:     darken($bc_1, 15%);
      }
    }

    .deleteBtn {
      border-radius:    0 !important;
      background-color: $red;
      border-color:     $red;
      color:            $white;

      &:hover, &:focus, &:active, &:active:focus, &.active:focus,
      &.focus, &:active.focus, &.active.focus {
        background-color: darken($red, 15%);
        border-color:     darken($red, 15%);
      }
    }
  }
}

.form-control {
  background-color: transparent;
}
</style>
